/**
 * Wait until the adapter reports that Automatic DOM Order is enabled.
 * Returns true if the flag flipped within the allotted time, otherwise false.
 */
export async function waitForAutoDomOrderEnabled(adapter, _temp) {
  let {
    pollIntervalMs = 500,
    maxWaitMs = 6000
  } = _temp === void 0 ? {} : _temp;
  const deadline = Date.now() + maxWaitMs;
  // Immediate check to short‑circuit in the common case
  if (adapter.getIsSiteAutoDOMOrderEnabled()) {
    return true;
  }
  while (Date.now() < deadline) {
    await new Promise(resolve => setTimeout(resolve, pollIntervalMs));
    if (adapter.getIsSiteAutoDOMOrderEnabled()) {
      return true;
    }
  }
  return false;
}
//# sourceMappingURL=wait-for-auto-dom-enabled.js.map